import { useState } from "react";
import { useAuth } from "@features/auth/AuthContext";
import { useSessionExpiry } from "@shared/hooks/useSessionExpiry";

export function SessionExpiryBanner() {
  const { user } = useAuth();
  const minutesLeft = useSessionExpiry(!!user);
  const [dismissed, setDismissed] = useState(false);

  if (!user || minutesLeft === null || dismissed) return null;

  const expired = minutesLeft <= 0;

  return (
    <div className={`session-banner ${expired ? "session-banner--expired" : "session-banner--warn"}`}>
      <span className="session-banner-text">
        {expired
          ? "⚠️ Tu sesión expiró. Guarda cualquier borrador y vuelve a iniciar sesión."
          : `⏱️ Tu sesión expira en ${minutesLeft} min. Guarda tu trabajo antes de que se cierre.`}
      </span>
      <button
        type="button"
        className="session-banner-close"
        onClick={() => setDismissed(true)}
        aria-label="Cerrar aviso"
      >
        ✕
      </button>
    </div>
  );
}
